import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useWorkspace } from '../context/WorkspaceContext';
import API_BASE from '../config/api';

const STATUS_OPTIONS = ['Proposal', 'Active', 'On Hold', 'Completed', 'Archived'];

export default function AddProjectModal({ isOpen, onClose, onSuccess }) {
  const { token } = useAuth();
  const { activeWorkspace } = useWorkspace();
  const [title, setTitle] = useState('');
  const [status, setStatus] = useState('Proposal');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  if (!isOpen) return null;

  function handleClose() {
    setTitle('');
    setStatus('Proposal');
    setStartDate('');
    setEndDate('');
    setError('');
    setSaving(false);
    onClose();
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!title.trim()) { setError('Title is required.'); return; }
    setSaving(true);
    setError('');
    try {
      const body = {
        workspace_id: activeWorkspace._id,
        title: title.trim(),
        status,
        start_date: startDate || undefined,
        end_date: endDate || undefined,
      };
      const res = await axios.post(`${API_BASE}/api/projects`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      handleClose();
      onSuccess(res.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create project.');
      setSaving(false);
    }
  }

  const labelStyle = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 500,
    fontSize: '11px',
    color: '#888888',
    letterSpacing: '1px',
    marginBottom: '6px',
    display: 'block',
  };

  const inputStyle = {
    width: '100%',
    backgroundColor: '#2a2a2a',
    border: '1px solid #444444',
    borderRadius: '4px',
    color: '#F5F5F5',
    fontFamily: "'Roboto', sans-serif",
    fontSize: '14px',
    padding: '9px 12px',
    outline: 'none',
    boxSizing: 'border-box',
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={handleClose}
    >
      <div
        style={{
          backgroundColor: '#2a2a2a',
          border: '1px solid #444444',
          borderRadius: '8px',
          padding: '32px',
          width: '440px',
          boxShadow: '0 24px 64px rgba(0,0,0,0.6)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 600,
            fontSize: '18px',
            color: '#F5F5F5',
            marginBottom: '24px',
          }}
        >
          New Project
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={labelStyle}>TITLE</label>
            <input
              autoFocus
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              style={inputStyle}
              placeholder="Project title"
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={labelStyle}>STATUS</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              style={{ ...inputStyle, cursor: 'pointer' }}
            >
              {STATUS_OPTIONS.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
            <div>
              <label style={labelStyle}>START DATE</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                style={{ ...inputStyle, colorScheme: 'dark' }}
              />
            </div>
            <div>
              <label style={labelStyle}>END DATE</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                style={{ ...inputStyle, colorScheme: 'dark' }}
              />
            </div>
          </div>

          {error && (
            <div
              style={{
                fontFamily: "'Roboto', sans-serif",
                fontSize: '13px',
                color: '#BF2634',
                marginBottom: '16px',
              }}
            >
              {error}
            </div>
          )}

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={handleClose}
              style={{
                backgroundColor: 'transparent',
                border: '1px solid #565656',
                color: '#888888',
                fontFamily: "'Roboto', sans-serif",
                fontWeight: 500,
                fontSize: '14px',
                padding: '9px 20px',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              style={{
                backgroundColor: '#BF2634',
                border: 'none',
                color: '#FFFFFF',
                fontFamily: "'Roboto', sans-serif",
                fontWeight: 500,
                fontSize: '14px',
                padding: '9px 24px',
                borderRadius: '4px',
                cursor: saving ? 'default' : 'pointer',
                opacity: saving ? 0.7 : 1,
              }}
            >
              {saving ? 'Creating...' : 'Create Project'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
